import styled from "@emotion/styled";
import React from "react";
import { observer } from "mobx-react-lite";
import AccountSupplyTable from "./AccountSupplyTable";
import AccountBorrowTable from "./AccountBorrowTable";
import { SupplyAndBorrowVMProvider } from "./SupplyAndBorrowVM";
import SizedBox from "@components/SizedBox";

interface IProps {}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const DesktopAccountSupplyAndBorrowImpl: React.FC<IProps> = () => {
  return (
    <Root>
      <AccountSupplyTable />
      <SizedBox height={24} />
      <AccountBorrowTable />
    </Root>
  );
};

const DesktopAccountSupplyAndBorrow: React.FC = () => {
  return (
    <SupplyAndBorrowVMProvider>
      <DesktopAccountSupplyAndBorrowImpl />
    </SupplyAndBorrowVMProvider>
  );
};

export default observer(DesktopAccountSupplyAndBorrow);
